/**
 * ReadinessIssueGroup - Einzelne Issue-Gruppe mit Produkt-Count
 *
 * Klickbar zum Filtern der Produkttabelle.
 */

import { Image, Type } from 'lucide-react'
import type { IssueGroup } from '@/lib/api/channel-readiness'

interface ReadinessIssueGroupProps {
  group: IssueGroup
  isActive?: boolean
  onClick?: (group: IssueGroup) => void
}

export function ReadinessIssueGroup({ group, isActive, onClick }: ReadinessIssueGroupProps) {
  const Icon = group.issue_type === 'image' ? Image : Type
  const iconColor = group.issue_type === 'image'
    ? 'text-emerald-500'
    : 'text-primary-500'

  const activeClass = isActive
    ? 'bg-primary-50 dark:bg-primary-900/20 ring-1 ring-primary-200 dark:ring-primary-800'
    : 'hover:bg-neutral-50 dark:hover:bg-neutral-800/50'

  return (
    <div
      role="button"
      tabIndex={0}
      className={`flex items-center justify-between py-2 px-3 rounded-lg cursor-pointer transition-colors ${activeClass}`}
      onClick={() => onClick?.(group)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.(group)
        }
      }}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Icon className={`h-4 w-4 flex-shrink-0 ${iconColor}`} />
        <span className="text-sm text-neutral-700 dark:text-neutral-300 truncate">
          {group.message}
        </span>
      </div>
      <span className="text-sm font-medium text-neutral-500 dark:text-neutral-400 tabular-nums ml-3">
        {group.product_count} Prod.
      </span>
    </div>
  )
}
